import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Residence from "./components/Residence";
import Searchbox from "./components/SearchBox";
import axios from "axios";
import ReactPaginate from "react-paginate";
import noData from "../images/no-data.svg";
import Filter from "./components/utils/Filter";

export default function Hostels(props) {
	const [hostels, setHostels] = useState([]);
	const [allObuasiHostels, setAllObuasiHostels] = useState([]);
	const [pageCount, setPageCount] = useState(0);
	const [page, setPage] = useState(1);
	const [limit, setLimit] = useState(24);
	const [isLoading, setIsLoading] = useState(false);
	const [activeFilter, setActiveFilter] = useState(false);
	// bumped when the filter is cleared so the normal list reloads
	const [refresh, setRefresh] = useState(0);
	// location.key changes on every nav click, so re-clicking the link refetches
	const location = useLocation();
	useEffect(() => {
		const controller = new AbortController();
		const fetchHostels = async () => {
			setIsLoading(true);
			try {
				const res = await axios({
					method: "get",
					url: `${process.env.REACT_APP_API_URL}/api/v1/residences/obuasi_campus?page=${page}&limit=${limit}`,
					signal: controller.signal,
				});
				setPageCount(Math.ceil(res.data.total / limit)); //set
				const arr = res.data.data.sort(() => Math.random() - 0.5);
				setHostels(arr);
				setAllObuasiHostels(res.data.all);
			} catch (error) {
				if (axios.isCancel(error)) return;
				console.log(error);
				setHostels([]);
			} finally {
				if (!controller.signal.aborted) setIsLoading(false);
			}
		};

		fetchHostels();
		return () => controller.abort();
	}, [page, limit, location.key, refresh]);

	const handlePageClick = (p) => {
		setPage(p.selected + 1);
		setLimit(limit);
	};
	return (
		<>
			<div className="container  margin-top">
				<div>
					<Filter
						key={location.key}
						type="Obuasi_Campus"
						setActiveFilter={setActiveFilter}
						setHostels={setHostels}
						onReset={() => setRefresh((r) => r + 1)}
					/>
				</div>
				<div className="residence-search-area">
					<div>
						<Searchbox type="Obuasi Campus Hostels" data={allObuasiHostels} />
					</div>
				</div>
				<div className="hostel-flex my-5">
					{isLoading ? (
						<>
							<div className="text-center " id="loading" />
							<div className="load-separator" />
						</>
					) : hostels?.length === 0 ? (
						<>
							<img
								className="text-center"
								src={noData}
								alt="..."
								style={{ width: 250, height: 250 }}
							/>{" "}
							<br />
						</>
					) : (
						hostels.map((item, index) => {
							return <Residence residence={item} key={item?._id} />;
						})
					)}
				</div>
				{activeFilter ? (
					""
				) : (
					<ReactPaginate
						breakLabel="..."
						nextLabel=">>"
						onPageChange={handlePageClick}
						// pageRangeDisplayed={5}
						pageCount={pageCount}
						forcePage={page - 1}
						previousLabel="<<"
						renderOnZeroPageCount={null}
						containerClassName="pagination justify-content-center"
						pageClassName="page-item"
						pageLinkClassName="page-link"
						activeClassName=" active"
						activeLinkClassName="active"
						breakClassName="page-item"
						breakLinkClassName="page-link"
						nextClassName="page-item"
						nextLinkClassName="page-link"
						previousClassName="page-item"
						previousLinkClassName="page-link"
					/>
				)}
			</div>
		</>
	);
}
